import {} from "appRedux/constants";
import {
  FETCH_ADMIN_END,
  FETCH_ADMIN_START,
  SAVE_ADMIN,
  SAVE_ADMIN_START
} from "../constants";
import { SAVE_TRANSACTION_PAGE } from "appRedux/constants";

const INIT_STATE = {
  loading: false,
  admins: [],
  adminPages: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_ADMIN_START: {
      return {
        ...state,
        loading: true
      };
    }
    case FETCH_ADMIN_END: {
      return {
        ...state,
        loading: false
      };
    }
    case SAVE_ADMIN_START: {
      return {
        ...state,
        loading: true
      };
    }
    case SAVE_ADMIN: {
      return {
        ...state,
        loading: false,
        admins: action.payload
      };
    }
    case SAVE_TRANSACTION_PAGE: {
      return {
        ...state,
        loading: false,
        adminPages: action.payload
      };
    }
    default:
      return state;
  }
};
